import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { MIN_ZOOM, MAX_ZOOM, getZoomIn, getZoomOut } from '@/util/zoom.js';
import actions from '@/action/panZoom.js';
import toolActions from '@/action/tools.js';

// import { library } from '@fortawesome/fontawesome-svg-core';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import SvgIcon from '@material-ui/core/SvgIcon';
import Tooltip from '@material-ui/core/Tooltip';

// import falPlusCircle from '@fortawesome/fontawesome-pro/js/light';
// import farPlusCircle from '@fortawesome/fontawesome-pro/js/regular';
// import fasPlusCircle from '@fortawesome/fontawesome-pro/js/solid';

// import falMinusCircle from '@fortawesome/fontawesome-pro/js/light';
// import farMinusCircle from '@fortawesome/fontawesome-pro/js/regular';
// import fasMinusCircle from '@fortawesome/fontawesome-pro/js/solid';

import { ReactComponent as ZoomOutIcon } from '@/icons/colorless/zoom_out.svg';
import { ReactComponent as ZoomInIcon } from '@/icons/colorless/zoom_in.svg';
import { ReactComponent as ShowAllIcon } from '@/icons/white/maximize.svg';
import { ReactComponent as ShowPrevIcon } from '@/icons/white/minimize.svg';

// import { withStyles } from '@material-ui/core/styles';
import styles from './ZoomToolbar.module.css';


// redo-alt
// undo-alt
// play
// 

// console.log('star', falExpand, farExpand, fasExpand);
// library.add(falExpand, farExpand, fasExpand);

/** Test component description */
class ZoomToolbar extends Component {
    constructor(props) {
        super(props);

        this.config = props.config;

        this.toggleMultiselect = this.toggleMultiselect.bind(this);

        // this.zoomTo = this.zoomTo.bind(this);

        this.state = {};

        const noop = ()=>{};
        // this.tweenZoom = this.props.tweenZoom ? this.props.tweenZoom.bind(this) : this.basicZoom.bind(this);
        // this.cancelTweenZoom = this.props.cancelTweenZoom ? this.props.cancelTweenZoom.bind(this) : noop;
        // this.tweenZoomUpdate = this.props.tweenZoomUpdate ? this.props.tweenZoomUpdate.bind(this) : noop;        
    }

    // basicZoom(targetZ) {
    //     this.props.setZoom(targetZ);
    // }

    toggleMultiselect() {
        // this.setState({
        //     multiselect: !this.state.multiselect
        // })

        this.props.setMultiselectDefault(!this.props.multiselect);

    }

    render() {

        const actions = {
            onClick: function(e) {
                console.log('click');
            },
            onTouchStart: function(e) {
                console.log('touch');
            },
            onTouchEnd: function(e) {
                console.log('touch end');
            },
            onMouseOver: function(e) {
                // console.log('over');
            },
            onMouseOut: function(e) {
                // console.log('out');
            }
        }

        const zoomDisplay = Math.round(this.props.z * 10) + '%';

        const getZoomDisplay = function(z) {
            if (z < .01) {
                return Number((z* 100).toFixed(2)) + '%';
            } else {
                return Math.round(z * 100) + '%';
            }
        }

        // <Button aria-label="Delete" variant="outlined" action={wtf}>
        // <FontAwesomeIcon icon={["fas", "minus-circle"]} />
        // <FontAwesomeIcon icon={["fas", "plus-circle"]} />
        // </Button>

        return (<div className={`ui ${styles.toolbar}`}>

            {
                this.props.isShowingAll ?

                <Tooltip title="Show Last" classes={{ tooltip: 'tooltip' }} enterDelay={800}> 
                <span>
                    <Button
                        aria-label="Show Last"
                        classes={{ root: styles.button, focusVisible: styles.buttonFocus }}
                        className="clickable"
                        variant="outlined"
                        disableFocusRipple
                        // action={wtf}
                        onClick={() => {
                            this.props.showPrev()
                            this.props.setCurrentTool(this.state.previousTool)
                            this.setState({
                                previousTool: null
                            })
                        }}

                        onMouseOver={actions.onMouseOver}
                        onMouseOut={actions.onMouseOut}
                    >
                        <SvgIcon><ShowPrevIcon /></SvgIcon>
                    </Button>
                </span>
            </Tooltip>
:
            <Tooltip title="Show All" classes={{ tooltip: 'tooltip' }} enterDelay={800}> 
                <span>
                    <Button
                        aria-label="Show All"
                        classes={{ root: styles.button, focusVisible: styles.buttonFocus }}
                        className="clickable"
                        variant="outlined"
                        disableFocusRipple
                        // action={wtf}
                        onClick={() => {

                            console.log(this.props.setCurrentTool)

                            this.props.showAll()
                            // this.setState({
                            //     previousTool: this.props.currentTool
                            // })
                            // this.props.setCurrentTool('ZOOM')
                        }}

                        onMouseOver={actions.onMouseOver}
                        onMouseOut={actions.onMouseOut}
                    >
                        <SvgIcon><ShowAllIcon /></SvgIcon>
                    </Button>
                </span>
            </Tooltip>

            }




            <Tooltip title="Zoom Out" classes={{ tooltip: 'tooltip' }} enterDelay={800}> 
                <span>
                    <Button
                        aria-label="Zoom Out"
                        classes={{ root: styles.button, focusVisible: styles.buttonFocus }}
                        className="clickable"
                        variant="outlined"
                        disableFocusRipple
                        // action={wtf}
                        onClick={() => {
                            this.props.setZoom(getZoomOut(this.props.z, 1));
                            // this.props.setZoom(getZoomOut(this.props.z))}
                        }}

                        onMouseOver={actions.onMouseOver}
                        onMouseOut={actions.onMouseOut}
                        disabled={this.props.z == MIN_ZOOM}
                    >
                        <SvgIcon><ZoomOutIcon /></SvgIcon>
                    </Button>
                </span>
            </Tooltip>

            <Tooltip title="Reset Zoom" classes={{ tooltip: 'tooltip' }} enterDelay={800}>
                <Button
                    aria-label="Reset Zoom"
                    className="clickable"
                    classes={{ root: styles.button, focusVisible: styles.buttonFocus }}
                    disableFocusRipple
                    variant="outlined"
                    onClick={() => this.props.resetZoom()}
                >
                    <div className={styles.textLabel + ' ' + styles.currentZoomPercentage}>{getZoomDisplay(this.props.z)}</div>
                </Button>
            </Tooltip>

            <Tooltip title="Zoom In" classes={{ tooltip: 'tooltip' }} enterDelay={800}>
                <span>
                    <Button
                        className="clickable"
                        aria-label="Zoom In"
                        classes={{ root: styles.button, focusVisible: styles.buttonFocus }}
                        disableFocusRipple
                        variant="outlined"
                        // action={wtf}
                        
                        onClick={() => {
                            this.props.setZoom(getZoomIn(this.props.z, 1));
                        }}


                        onMouseOver={actions.onMouseOver}
                        onMouseOut={actions.onMouseOut}
                        disabled={this.props.z == MAX_ZOOM}
                    >
                        <SvgIcon><ZoomInIcon /></SvgIcon>
                    </Button>
                </span>
            </Tooltip>




            {/* <Tooltip title="Marquee" classes={{ tooltip: 'tooltip' }} enterDelay={800}> 
                <span>
                    <Button
                        aria-label="Marquee"
                        classes={{ root: 'button', focusVisible: 'button-focus' }}
                        className="clickable"
                        variant="outlined"
                        disableFocusRipple
                        // action={wtf}
                        onClick={() => {
                            this.props.setCurrentTool('MARQUEE');
                        }}

                        onMouseOver={actions.onMouseOver}
                        onMouseOut={actions.onMouseOut}

                        disabled={this.props.currentTool == 'MARQUEE'}
                    >
<div className={styles.textLabel}>Marquee</div>
                    </Button>
                </span>
            </Tooltip> */}



            {this.props.children}
        </div>);
    }
}

const mapStateToProps = (state, ownProps) => {
    return Object.assign({}, { 
        z: state.camera.zoom,
        // width: state.camera.size.width,
        // height: state.camera.size.height,
        // panX: state.camera.pan.x,
        // panY: state.camera.pan.y,
        multiselect: state.tool.multiselect,
        currentTool: state.tool.current
    }, ownProps);
}

ZoomToolbar.displayName = "ZoomToolbarComponent";
const connectedComponent = connect(
    mapStateToProps,
    {
        // ...actions,
        ...toolActions
    }
)(ZoomToolbar);
connectedComponent.displayName = "ZoomToolbar";

/**
 * Huzzah!
 */
ZoomToolbar.propTypes = {

};

export default connectedComponent;
export { ZoomToolbar as ZoomToolbarComponent };